// Shared in-flight cache for Revolut order creation.
//
// The checkout page renders the payment form twice (desktop and mobile layout),
// and each mount used to POST /api/revolut/create-order — every checkout minted
// two Revolut orders, and only one of them could end up on the transaction. The
// Aug 2026 double-booking incident (two transactions pointing at different
// orders for one payment) started exactly there.
//
// Both mounts now share one create-order promise per (context, amount, kind).
// The cache lives for the SPA session; a paid order's entry is cleared on
// payment success so a later checkout for the same listing/amount gets a fresh
// order instead of an already-paid one.

const orders = new Map();

export const revolutOrderCacheKey = ({ transactionId, listingId, amount, isSecondPayment }) =>
  [transactionId || listingId || 'anon', String(amount), isSecondPayment ? 'second' : 'first'].join(
    '|'
  );

export const getOrCreateRevolutOrder = (key, create) => {
  if (!orders.has(key)) {
    const promise = create().catch(e => {
      // A failed creation must not poison the cache — the next mount retries.
      orders.delete(key);
      throw e;
    });
    orders.set(key, promise);
  }
  return orders.get(key);
};

export const clearRevolutOrder = key => {
  orders.delete(key);
};
